export default __webpack_public_path__ + "static/media/pdf-specs-display-luxury.56050e53.pdf";